/* globals jQuery */

import 'jquery-validation'
import 'jquery-validation/dist/localization/messages_es'
import { AppResponse } from '../modules/ajax'
import cache from '../modules/cache'

interface EditorUrls {
  store?: string;
  update?: string;
  delete?: string;
}

const formSelectors = {
  dialogContainer: '#editorBootstrapDialog',
  dialogContent: '#editorBootstrapDialog .modal-body',
  formContainer: '#formulario_mod',
  buttonsContainer: '#button-controls',
  acceptButton: '#buttonAceptar',
  cancelButton: '#buttonCancelar',
  deleteButton: '#buttonEliminar',
  reloadPageButton: '.reload-page-button'
}

const buttonSpinner = `
    <div class="text-center">
      <i class="fas fa-circle-notch fa-spin"></i>
    </div>
  `

export const openDialog = (): void => {
  jQuery(formSelectors.dialogContainer).modal('show')
}

const closeDialog = (): void => {
  jQuery(formSelectors.dialogContainer).modal('hide')
}

export const fillContent = (content: string): void => {
  jQuery(formSelectors.dialogContent).html(content)
}

export const showWaiting = (): void => {
  jQuery(formSelectors.dialogContent).addClass('wait')
}

export const hideWaiting = (): void => {
  jQuery(formSelectors.dialogContent).removeClass('wait')
}

export const showLoading = (): void => {
  fillContent(`
    <div class="text-center padding-all">
      <i class="fas fa-circle-notch fa-spin fa-5x"></i>
    </div>
  `)
}

const setupResponsePageButtons = (): void => {
  jQuery(formSelectors.reloadPageButton)
    .on('click', () => {
      cache.local().forget('/menu/inicio')
      setTimeout(() => {
        window.location.reload()
      }, 100)
    })
    .focus()
}

export const showDialogContent = (content: string): void => {
  openDialog()
  fillContent(content)
  hideWaiting()
  setupForm()
  setupResponsePageButtons()
}

export const showError = (
  errorMessage: string,
  errorObject?: AppResponse
): void => {
  hideWaiting()

  if (errorObject !== undefined) {
    const messages: string[] = []

    if (errorObject.errors) {
      messages.push(errorObject.errors[0])
    }

    messages.push(
      'Abre la consola para encontrar más información sobre el error.'
    )

    console.log(
      '%cInternal server error%cDebug information',
      'color: white; background-color: #bf3c1a; padding: 2px 5px;',
      'color: white; background-color: #e96224; padding: 2px 5px;',
      errorObject
    )

    fillContent(`
      <div class="text-center alert alert-danger">
        ${messages.join('<br>')}
      </div>
    `)
  } else {
    fillContent(errorMessage)
  }

  setupResponsePageButtons()
}

const getUrls = (): EditorUrls => {
  return jQuery(formSelectors.buttonsContainer).data('urls')
}

const getId = (): number | undefined => {
  const id = jQuery('#id').val()

  if (id) {
    return id as number
  }

  return undefined
}

const showDelete = (): boolean => {
  return !!jQuery(formSelectors.buttonsContainer).data('show-delete-button')
}

const requestAjax = (
  url: string,
  data: string,
  trigger: 'updated' | 'created'
) => {
  const jQForm = jQuery(formSelectors.formContainer)
  const jQAcceptButton = jQuery(formSelectors.acceptButton)

  jQuery
    .ajax({
      url: url,
      headers: {
        Accept: 'text/partial+html; charset=utf-8'
      },
      method: 'post',
      data: data,
      success: (response) => {
        showDialogContent(response)

        jQAcceptButton.prop('disabled', '').html('Aceptar')
        jQForm.trigger(trigger)
      }
    })
    .fail((response) => {
      showError(response.responseText, response.responseJSON)
    })
}

const setupValidator = (): void => {
  const urls = getUrls()
  const collectData = () => jQForm.serialize()
  const jQForm = jQuery(formSelectors.formContainer)
  const jQAcceptButton = jQuery(formSelectors.acceptButton)

  jQForm.validate({
    submitHandler: () => {
      jQForm.trigger('submitted')
      jQAcceptButton.prop('disabled', 'disabled').html(buttonSpinner)

      if (getId() !== undefined) {
        if (urls.update !== undefined) {
          showWaiting()
          requestAjax(urls.update, collectData(), 'updated')
        }

        return false
      }

      if (urls.store !== undefined) {
        showWaiting()
        requestAjax(urls.store, collectData(), 'created')
      }

      return false
    },

    rules: {
      AccordionField: {
        required: true
      }
    },

    ignore: '.note-editor *, .jsoneditor *',

    invalidHandler: (_e, validator) => {
      for (let i = 0; i < validator.errorList.length; i++) {
        jQuery(validator.errorList[i].element)
          .parents('.panel-collapse.collapse')
          .collapse('show')
      }
    },

    errorElement: 'em',

    errorPlacement: (error, element) => {
      // Add the `help-block` class to the error element
      error.addClass('help-block')
      if (element.prop('type') === 'checkbox') {
        error.insertAfter(element.parent('label'))
      } else {
        error.insertAfter(element)
      }
    },

    highlight: (element) => {
      jQuery(element)
        .parents('.form-group')
        .addClass('has-error')
        .removeClass('has-success')
    },

    unhighlight: (element) => {
      jQuery(element)
        .parents('.form-group')
        .addClass('has-success')
        .removeClass('has-error')
    }
  })
}

export const setupForm = (): void => {
  console.debug('Setting up form...')

  const urls = getUrls()
  const jQCancelButton = jQuery(formSelectors.cancelButton)
  const jQDeleteButton = jQuery(formSelectors.deleteButton)

  setupValidator()

  jQuery('[data-toggle="tooltip"]').tooltip()

  jQCancelButton.on('click', () => {
    closeDialog()
  })

  if (showDelete() === true && urls.delete !== undefined) {
    jQDeleteButton.on('click', () => {
      if (confirm('¿Está seguro de eliminar el item?')) {
        showWaiting()

        jQDeleteButton.prop('disabled', 'disabled').html(buttonSpinner)

        if (urls.delete !== undefined) {
          jQuery
            .post(urls.delete, { id: getId() }, (response) => {
              showDialogContent(response)
            })
            .fail((response) => {
              // console.log(response)
              showError(
                `${response.statusText}: ${response.responseText}`,
                response.responseJSON
              )
            })
        }
      }
    })
  }
}
